import { AfterViewInit, Component, ElementRef, Host, HostListener, ViewChild } from '@angular/core';
import { FingerprintPatternIcon, LucideAngularModule } from 'lucide-angular';

@Component({
  selector: 'app-test',
  imports: [LucideAngularModule],
  templateUrl: './test.html',
  styleUrl: './test.scss',
})
export class TestComponent{
  readonly FingerprintPatternIcon = FingerprintPatternIcon;

}
